import { useEffect } from 'react';
import { ComponentType } from '@wix/dev-center-client';
import { useDebugLog } from '@wix/cli-debug-log';
import { useErrorReporter } from '@wix/cli-error-reporting';
import { useMetasiteManagerClient } from '@wix/metasite-manager-client';
import { useSite } from './site/index.js';
import { useProjectModel } from '../../../model.js';
import { useDevEnvironment } from '../DevEnvironment.js';

export function useERCManifestUpdateNotifier() {
  const { siteId } = useSite();
  const { devCenterWatcher } = useDevEnvironment();
  const metasiteManagerClient = useMetasiteManagerClient({ siteId });
  const {
    model: {
      config: { appId },
    },
  } = useProjectModel();
  const writeToDebugLog = useDebugLog();
  const errorReporter = useErrorReporter();

  useEffect(() => {
    const unsubscribe = devCenterWatcher.onManifestUpdated(
      ({ updatedComponents }) => {
        const editorComponentsUpdated = updatedComponents.filter(
          (comp) =>
            comp.compType === ComponentType.PANEL ||
            comp.compType === ComponentType.EDITOR_REACT_COMPONENT
        );

        if (editorComponentsUpdated.length > 0) {
          metasiteManagerClient
            .distributeClientUpdate(appId)
            .catch((error: unknown) => {
              errorReporter.reportError(error);
              writeToDebugLog(error);
            });
        }
      }
    );
    return () => {
      unsubscribe();
    };
  }, [
    devCenterWatcher,
    metasiteManagerClient,
    appId,
    writeToDebugLog,
    errorReporter,
  ]);
}
